module.exports = __webpack_public_path__ + "media/images/logotype-bleu-15a1a34f3c2fc4c42fc0535c885eb68b.svg";